module.exports = __webpack_public_path__ + "img/logo_anclivepa.779a3c46.png";